import { withChartLayout } from 'components/common';
import SpecialPrecautionsIsolationAssessment from 'components/features/chart/system-assessment/special-precautions-isolation-assessment/SpecialPrecautionsIsolationAssessment';

const SpecialPrecautionsIsolationAssessmentPage = withChartLayout('Special Precautions - Isolation Assessment')(SpecialPrecautionsIsolationAssessment);
export default SpecialPrecautionsIsolationAssessmentPage;
